import { render } from "./EditableCustomField.vue?vue&type=template&id=c2296a2a"
import script from "./EditableCustomField.vue?vue&type=script&lang=js"
export * from "./EditableCustomField.vue?vue&type=script&lang=js"

import "./EditableCustomField.vue?vue&type=style&index=0&id=c2296a2a&lang=scss"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__